jQuery(document).ready(function ($) {
  if ($(window).width() < 968) {
    $(".deliveryinfo > .rless").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      arrows: false,
      infinite: true,
      rtl: false,
    });
  }

  if($("body.template-collection").length && window.location.href.indexOf('hideAge') > -1) {
    $("#Details-3-template--23584914407728__product-grid").hide();
  }
});
